<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-product-documents-dynamic-list" class="ag-grid-container">

    <vs-alert color="danger" title="Document Type Not Found" :active.sync="type_not_found">
      <span>Dynamic Document type with id: {{ typeId }} not found. </span>
    </vs-alert>

    <div class="vx-card p-4" v-if="type">
      <grid-panel
          :column-defs="columnDefs"
          height="xl"
          :url="() => this.$api.productDynamic.list({ params: {DynamicType_FK: typeId}})"
          ref="grid"
          :auto-size="true"
          @rowClicked="edit"
          :title="type.Type"
      >
        <vs-dropdown-item v-if="componentAccess.canCreate.access">
          <span
              class="flex items-center"
              @click="$router.push({ name: 'dynamic.create' })"
          >
            <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Upload new {{ type.Type }}</span>
          </span>
        </vs-dropdown-item>
      </grid-panel>

    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import CellRendererVerified from "@/views/components/ag-grid/cell-renderer/CellRendererVerified";
import DynamicDocumentMixin from "@/components/mixins/DynamicDocumentMixin";

export default {
  components: {
    TGrid,
    GridPanel,
    CellRendererVerified,
  },
  mixins: [DynamicDocumentMixin, CellMatchingMixin, CanAccessMixin],
  data () {
    return {
      searchQuery: '',
      showDeleted: false,
      searchParams: {
        params: {
          DynamicType_FK: this.typeId,
        }
      },
      componentAccess: {
        canCreate: {
          route: 'dynamic.create',
          access: false,
        },
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'Friendly Name',
          field: 'FriendlyName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'File',
          field: 'FileName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Caption',
          field: 'LoaderName',
          filter: 'agTextColumnFilter',
        },
      ],
    }
  },
  watch: {
    '$route.params.typeId': {
      async handler(newId) {
        await this.getType(newId);
        this.$refs.grid.list();
      },
    }
  },
  methods: {
    edit({data}) {
      this.$router.push({ name: 'dynamic.edit', params: { id: data.id }}).catch(() => {});
    }
  },
}

</script>

<style lang="scss">
</style>
